<template>
    <div class="col-12 col-sm-10 col-md-9 row" style="min-height:36px">
        <div
            v-if="title"
            class="col-grow title gray-5"
            style="display: flex;align-items: center;"
        >
            {{ title }}
        </div>
        <slot/>
        <q-btn
            v-if="optionButton"
            no-caps
            no-wrap
            flat
            color="primary"
            style="font-weight: bold"
            @click="onButton"
        >
            {{ optionButton }}
        </q-btn>
        <q-toggle
            size="lg"
            :disable="disable"
            v-if="optionToggle"
            v-model="toggle"
            checked-icon="check"
            color="green"
            unchecked-icon="clear"
        />
        <div
            v-if="optionText"
            :class="computedOptionTextClass"
            style="display: flex;align-items: center;padding: 0px 16px 0px 0px;flex-direction: row-reverse;"
        >
            {{ optionText }}
        </div>
    </div>
</template>

<script>
import { QToggle } from "quasar";
const components = {
    QToggle,
};
export default {
    name: "TileBar",
    props: [
        "title",
        "optionButton",
        "value",
        "optionToggle",
        "disable",
        "optionText",
        "optionTextClass",
    ],
    components: {
        ...components,
    },
    data() {
        return {
            toggle: this.value,
        };
    },
    computed: {
        computedOptionTextClass() {
            return "col-grow title text-gray-5 " + this.optionTextClass;
        },
    },
    watch: {
        value(newValue) {
            this.toggle = newValue;
        },
        toggle(newValue) {
            this.handleToggle(newValue);
        },
    },
    methods: {
        handleToggle(value) {
            this.$emit("input", value);
        },
        onButton() {
            this.$emit("on-button");
        },
    },
};
</script>

<style scoped>
.title {
    font-size: 18px;
    font-weight: bold;
    line-height: 36px;
    padding-left: 16px;
    /* padding-top: 10px; */
}
</style>
